import React from 'react';
import Button from 'jbc-front/components/Button';
import { SOCIAL_INSURANCE_NOTIFICATION_SUBMISSION_TYPES } from 'src/constants/Options';
import CommonModal from 'jbc-front/components/CommonModal';
import { RadioField, TextField } from 'jbc-front/components/Form';
import { ErrorsSection } from 'src/components';
import styles from './CsvModal.scss';

const CsvModal = props => {
  const { handleSubmit, errors, submitting, pristine, submit, isOpen, hideModal, insuranceType } = props;

  return (
    <CommonModal className={styles.modal} ariaHideApp={false} {...{ isOpen, hideModal }}>
      <CommonModal.Header hideModal={hideModal}>賞与支払届CSVダウンロード</CommonModal.Header>
      <CommonModal.Body>
        <form onSubmit={handleSubmit} className={styles.modalForm}>
          <ErrorsSection errors={errors} />
          <div className={['it', 'other_association'].includes(insuranceType) ? styles.itemBox : styles.none}>
            <p>提出先</p>
            <RadioField
              required
              label="提出先"
              name="paymentFor"
              options={SOCIAL_INSURANCE_NOTIFICATION_SUBMISSION_TYPES}
            />
          </div>
          <div className={styles.itemBox}>
            <p>事業主氏名</p>
            <div className={styles.nameBox}>
              <TextField required label="姓" type="text" name="businessOwnerLastName" maxLength="10" />
              <TextField required label="名" type="text" name="businessOwnerFirstName" maxLength="10" />
            </div>
          </div>
          <div className={styles.itemBox}>
            <p>媒体通番</p>
            <TextField required label="媒体通番" type="text" name="serialNumber" maxLength="3" />
          </div>
          <div className={styles.buttonBox}>
            <Button onClick={hideModal} className="u-mr20">
              キャンセル
            </Button>
            <Button primary onClick={submit} disabled={pristine || submitting}>
              ダウンロード
            </Button>
          </div>
        </form>
      </CommonModal.Body>
    </CommonModal>
  );
};

export default CsvModal;
